import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { fetchOwnerHorsesHistory } from "../../redux/getReducer/getOwnerHorsesHistory";
import Moment from "react-moment";
import PleaseWait from "../Reuseable/PleaseWait";
import arrow1 from "../../assets/image 13 (Traced).png";
import { fetchownerhorseStats } from "../../redux/getReducer/getOwnerHorses";
import { truncateRaceType, toTitleCase } from "../../service/stringUtils";
import { IoIosArrowDropdownCircle, IoMdPlay } from "react-icons/io";
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";
import ScrollContainer from "react-indiana-drag-scroll";
import { Accordion, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import Pagination from "../../pages/Pagination";
import VideoFrame from "../Modal/VideoFrame";

// Isolated Style Import
// import "./StatsTabNew.css"; 

const Stats = ({ id }) => {
  const { data: ownerhorsestats } = useSelector((state) => state.ownerhorsestats);
  const { data: OwnerHorsesHistory } = useSelector((state) => state.OwnerHorsesHistory);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let totalcountdata = ownerhorsestats ? ownerhorsestats.totalcount : "";
  let totalpagesdata = ownerhorsestats ? ownerhorsestats.totalPages : "";
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(11);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleShowJockey = (data) => {
    const jId = data?._id || data;
    if (jId) navigate("/jockey-detail?" + jId);
  };

  const handleShowRace = (id) => {
    if (id) navigate("/race-detail?" + id);
  };

  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");
  const [ShowHorse, setShowHorse] = useState(false);
  const [modaldatasHorse, setmodaldatasHorse] = useState();
  const handleHorseCloses = () => setShowHorse(false);
  const handleShowHorse = (data) => {
    const id = data?._id || data;
    if (id) navigate("/horse-detail?" + id);
  };

  useEffect(() => {
    dispatch(fetchownerhorseStats({ id, currentPage }));
  }, [currentPage, id, dispatch]);

  const [shows, setShows] = useState(false);
  const [modaldatas, setmodaldatas] = useState();
  const handleCloses = () => setShows(false);
  const handleShows = async (data) => {
    setmodaldatas(data);
    await setShows(true);
  };

  const [compIndex, setCompIndex] = useState(null);

  const FirstLetter = (data) => {
    return data ? data.substring(0, 1) : "";
  }

  const handleTrainerRecord = (horseid, index) => {
    if (compIndex === index) { setCompIndex(null); return; }
    setCompIndex(index);
    dispatch(fetchOwnerHorsesHistory({ horseid, id }));
  };

  function distanceLabel(distance, rank) {
    const DistanceTobeChecked = parseFloat(distance);
    if (DistanceTobeChecked.toFixed(2) > 25) return "Dist";
    else if (DistanceTobeChecked.toFixed(2) == 0.05 && rank < 80) return "SHd";
    else if (DistanceTobeChecked.toFixed(2) == 0.10 && rank < 80) return "Hd";
    else if (DistanceTobeChecked.toFixed(2) == 0.25 && rank < 80) return "Nk";
    else if (DistanceTobeChecked.toFixed(2) == 0.01 && rank < 80) return "Ns";
    else if (DistanceTobeChecked.toFixed(2) == 0.00 && rank < 80) return rank === 1 ? 0 : "Dh";
    else return distance;
  }


  return (
    <div className="stats-new-master-container">
      {/* --- DIV BASED TABLE HEAD (9 Columns like Template) --- */}
      <div className="stats-new-main-thead">
        <div>{t("Horse Name")}</div><div>{t("Runs")}</div><div>{t("Wins")}</div><div>{t("Second")}</div>
        <div>{t("Third")}</div><div>{t("Fourth")}</div><div>{t("Fifth")}</div><div>{t("Earning")}</div>
        <div>{t("Wins")}%</div><div></div>
      </div>

      <div className="stats-new-accordion-box">
        {ownerhorsestats?.data && ownerhorsestats?.data?.map((item, i) => (
          <Accordion key={i} activeKey={compIndex === i ? "0" : ""}>
            <Accordion.Item eventKey="0" className="stats-new-acc-item">
              <Accordion.Header className="stats-new-header-custom" onClick={() => handleTrainerRecord(item._id, i)}>
                 <div className="stats-new-header-grid">
                    <div className="new-bold-blue clickable-text" onClick={(e) => { e.stopPropagation(); handleShowHorse(item._id); }}>{cookiedata === "en" ? item.NameEn : item.NameAr}</div>
                    <div>{item?.Runs}</div><div>{item?.wins}</div>
                    <div>{item?.second}</div><div>{item?.third}</div>
                    <div>{item?.fourth}</div><div>{item?.fifth}</div>
                    <div className="new-bold">AED {item?.earning || 0}</div>
                    <div>{Number(item?.winspercentage || 0).toFixed(2)}</div>
                    <div style={{textAlign:'right'}}>
                      {compIndex === i ? <MdKeyboardArrowDown className="stats-new-arrow-icon" /> : <MdKeyboardArrowRight className="stats-new-arrow-icon" />}
                    </div>
                 </div>
              </Accordion.Header>

              <Accordion.Body style={{padding: 0}}>
                 {compIndex === i && (
                    <div className="stats-new-inner-container">
                       <ScrollContainer className="stats-new-inner-scroll">
                          <div className="stats-new-inner-grid-table">
                             {/* 16 COLUMNS HEADER BINDING */}
                             <div className="stats-new-inner-grid-thead">
                                 <div>{t("Date")}</div><div>{t("Crs")}</div><div>{t("Horse Name")}</div><div>{t("Dist")}</div><div>{t("RT")}</div><div>{t("Time")}</div><div>{t("Jockey")}</div><div>{t("Wgt")}</div><div>{t("FP")}</div><div>{t("Len")}</div><div>{t("RN")}</div><div>{t("BtBy")}</div><div>{t("Kgs")}</div><div>{t("Draw")}</div><div>{t("OR")}</div><div>{t("Link")}</div>
                             </div>

                             <div className="stats-new-inner-grid-tbody">
                                {OwnerHorsesHistory === undefined ? <PleaseWait /> : (
                                  OwnerHorsesHistory.length === 0 ? <div className="text-center py-3">{t("No History Yet")}</div> : 
                                  OwnerHorsesHistory.map((inner, idx) => {
                                      const ground = inner.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.TrackLengthData?.GroundTypeModelData?.NameEn;
                                      const rowBg = ground === "Dirt" ? "#e3d4ca" : ground === "Turf" ? "#cbedba" : "#949494";
                                      return (
                                        <div key={idx} className="stats-new-inner-row" style={{ backgroundColor: rowBg, color: '#343433' }}>
                                           <div onClick={() => handleShowRace(inner.RaceID)} className="new-clickable-white"><Moment format="DD/MM/YYYY">{inner.RaceResultData?.Day}</Moment></div>
                                           <div>{cookiedata === "en" ? inner.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceCourseData?.AbbrevEn : inner.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceCourseData?.AbbrevAr}({FirstLetter(cookiedata === "en" ? ground : inner.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.TrackLengthData?.GroundTypeModelData?.NameAr)})</div>
                                           <div className="clickable-text" onClick={(e) => { e.stopPropagation(); handleShowHorse(item._id); }}>{cookiedata === "en" ? toTitleCase(item.NameEn) : item.NameAr}</div>
                                           <div>{inner.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.TrackLengthData?.TrackLength}</div>
                                           <div className="stats-new-truncate">{cookiedata === "en" ? toTitleCase(truncateRaceType(inner.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceTypeModelData?.NameEn)) : inner.RaceResultData?.RacehorsesData?.[0]?.RacehorsesData?.RaceTypeModelData?.NameAr}</div>
                                           <div>{inner.RaceTime}</div>
                                           <div onClick={() => handleShowJockey(inner.JockeyOnRaceDataResult?._id)} className="new-clickable-white">{cookiedata === "en" ? toTitleCase(inner.JockeyOnRaceDataResult?.ShortNameEn || inner.JockeyOnRaceDataResult?.NameEn) : inner.JockeyOnRaceDataResult?.ShortNameAr || inner.JockeyOnRaceDataResult?.NameAr}</div>
                                           <div>{inner.RaceResultData?.RacehorsesData?.[0]?.JockeyRaceWeight}</div>
                                           <div>{cookiedata === "en" ? toTitleCase(inner.FinalPositionDataHorse?.NameEn) : inner.FinalPositionDataHorse?.NameAr}</div>
                                           <div>{distanceLabel(inner.Distance, inner.FinalPositionDataHorse?.Rank)}</div>
                                           <div>{inner.Runners}</div>
                                           <div className="stats-new-truncate new-clickable-white" onClick={() => handleShowHorse(inner.BeatenByData?._id || inner.BeatenByData)}>{inner.BeatenByData ? (cookiedata === "en" ? toTitleCase(inner.BeatenByData.NameEn) : inner.BeatenByData.NameAr) : (cookiedata === "en" ? toTitleCase(inner.HorseIDData?.HorseBeatenByEnglishName) : inner.HorseIDData?.HorseBeatenByArabicName)}</div>
                                           <div>{inner.BeatenByData ? inner.BeatenByData.WinningHorseJockeyWeight : (inner.HorseIDData?.BeatenByJockeyWeight || 0)}</div>
                                           <div>{inner.RaceResultData?.RacehorsesData?.[0]?.HorseNo || "-"}</div>
                                           <div>{inner.Rating || 0}</div>
                                           <div onClick={() => handleShows(inner.VideoLink)} className="new-mini-play-white"><IoMdPlay /></div>
                                        </div>
                                      )
                                  })
                                )}
                             </div>
                          </div>
                       </ScrollContainer>
                    </div>
                 )}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ))}
      </div>

      <div className="stats-new-pagination">
          <Pagination postsPerPage={postsPerPage} totalPosts={totalcountdata} paginate={paginate} currentPage={currentPage} TotalPages={totalpagesdata} />
      </div>

      {/* --- ALL MODALS PRESERVED --- */}
      <Modal show={shows} onHide={handleCloses} size="lg" centered><Modal.Body><VideoFrame data={modaldatas} /></Modal.Body></Modal>

    </div>
  );
};

export default Stats;